module.exports = __webpack_public_path__ + "img/svg/step7.d1b5c3b1707c0b9180949c5ba12c6780.svg";